// extracted by mini-css-extract-plugin
module.exports = {"gsapdGroupd":"gsapdGroupd_gsapdGroupd__QGccg"};